import React from 'react';

import { createStyle, createStyles } from '../../../utils/createStyle';

import { FieldContainer, FieldContainerProps } from './FieldContainer';

import { FieldWrapperProps } from 'components/fields/FieldWrapper';

export interface FieldOptionProps {
    text: string;
    value: string;
    disabled?: boolean;
}

export type ComboFieldProps = FieldContainerProps &
    FieldWrapperProps &
    React.InputHTMLAttributes<HTMLSelectElement> & {
        inputRef?: React.Ref<HTMLSelectElement>;
        options: FieldOptionProps[];
    } & {
        containerClassName?: string;
    };

const styles = createStyles({
    container: createStyle('', {
        backgroundColor: '#F7F7F7',
    }),
    titleHeader: createStyle('text-xs px-2 text-grey-2'),
    titleBody: createStyle(''),
    titleInput: createStyle('w-full p-1 px-2', {
        // Changed from 'transparent' to rgba to avoid
        // issue on (iOS Safari).
        // It was hiding the select indicator arrows.
        background: 'rgba(255, 255, 255, .01)',
        height: '2rem',
    }),
    titleFooter: createStyle('grid text-center text-xs text-grey-3 gap-2 px-2', {
        gridTemplateColumns: 'max-content max-content max-content',
    }),
});

export const FieldCombo = ({
    label,
    name,
    options,
    value,
    error,
    onChange,
    required,
    containerClassName,
    controlClassName,
    ...props
}: ComboFieldProps) => {
    return (
        <FieldContainer
            label={label}
            className={containerClassName}
            required={required}
            controlClassName={controlClassName}
            error={error}
        >
            <select
                {...props}
                name={name}
                className={styles.titleInput}
                onChange={onChange}
                value={value}
            >
                {options.map((option) => (
                    <option
                        value={option.value}
                        key={option.value}
                        disabled={option.disabled || false}
                    >
                        {option.text}
                    </option>
                ))}
            </select>
        </FieldContainer>
    );
};
